import { useEffect, useRef } from "react";

function TextEditor({ content, onChange, handleMediaUpload }) {
    const editorRef = useRef(null);
    const editorId = "legal-pages-classic-editor";
    const isInitialized = useRef(false);
    const isUpdatingFromProp = useRef(false);

    // Initialize editor once
    useEffect(() => {
        const textarea = editorRef.current;
        if (!textarea || isInitialized.current) return;

        window.tinymce.init({
            target: textarea,
            plugins: ["link", "lists", "textcolor", "charmap"],
            toolbar:
                "formatselect add_custom_wp_media | bold italic underline strikethrough blockquote | \
                 forecolor backcolor | link | alignleft aligncenter alignright alignjustify | \
                 bullist numlist",
            relative_urls: false,
            remove_script_host: false,
            document_base_url: window.location.origin + "/",
            resize: false,
            menubar: false,
            branding: false,
            width: '100%',
            height: 400,
            setup: (editor) => {
                editor.addButton("add_custom_wp_media", {
                    text: "Add Media",
                    icon: "image",
                    onclick: () => handleMediaUpload(),
                });

                editor.on("Change KeyUp Paste", () => {
                    if (!isUpdatingFromProp.current) {
                        onChange(editor.getContent());
                    }
                });

                editor.on("init", () => {
                    isInitialized.current = true;
                    if (content) {
                        editor.setContent(content);
                    }
                });
            },
        });

        return () => {
            const editor = window.tinymce.get(editorId);
            if (editor) {
                editor.destroy();
                isInitialized.current = false;
            }
        };
    }, []); // Empty dependency array - initialize only once

    // Update content from props (e.g., when template is loaded)
    useEffect(() => {
        const editor = window.tinymce.get(editorId);
        if (editor && isInitialized.current) {
            const currentContent = editor.getContent();
            if (currentContent !== content) {
                isUpdatingFromProp.current = true;
                editor.setContent(content || '');
                setTimeout(() => {
                    isUpdatingFromProp.current = false;
                }, 50);
            }
        }
    }, [content]);

    return (
        <textarea id={editorId} ref={editorRef}></textarea>
    );
}

export default TextEditor;